// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_aJvbm","breadcrumbs":"index_breadcrumbs_ssYpg"};